var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupersocialite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "badgeStatus",
    d: "M54.7366 20.6096L67.5266 42.7663C73.9499 53.893 65.9199 67.803 53.0699 67.803H27.4899C14.6399 67.803 6.60991 53.893 13.0332 42.7663L25.8266 20.6096C32.2499 9.48298 48.3132 9.48298 54.7399 20.6096",
    fill: "#FFD657",
    stroke: "#FFD657",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8833 57.3066L33.8167 72.1566",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8667 71.8066C36.0567 76.1366 39.6134 76.6366 39.6134 76.6366",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8667 71.8066C30.58 75.3733 27.02 74.8866 27.02 74.8866",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7333 50.5833C44.1366 54.87 40.1766 57.8633 35.8899 57.2666C31.6033 56.67 28.6099 52.71 29.2066 48.4233L32.4599 25.0566L47.9833 27.2166L44.7299 50.5833H44.7333Z",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4466 53.2666C34.3733 52.9766 32.92 51.0566 33.21 48.98L35.9066 29.6133",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.74 42.0264L71.1733 55.0497",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71 54.7432C75.3767 56.8332 78.5 55.0598 78.5 55.0598",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71 54.7432C70.5733 59.5765 67.46 61.3632 67.46 61.3632",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9233 21.3701L41.3333 18.5835L54.9466 10.8135L66.6433 31.3035C68.7899 35.0635 67.4799 39.8501 63.7233 41.9935C59.9633 44.1401 55.1766 42.8301 53.0333 39.0735L52.1399 37.5101",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.72 38.483C59.9 39.5197 57.5767 38.8863 56.54 37.0663L46.8467 20.083",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5835 37.9639L9.16016 50.9905",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 50.6846C9.76016 55.5146 12.8768 57.3012 12.8768 57.3012",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 50.6846C4.95683 52.7779 1.8335 51.0046 1.8335 51.0046",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2936 35.0041C25.1502 38.7641 20.3636 40.0741 16.6036 37.9308C12.8436 35.7875 11.5336 31.0008 13.6769 27.2408L25.3636 6.74414L38.9802 14.5075L35.3402 20.8941",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6036 34.4206C16.7836 33.3839 16.1469 31.0606 17.1869 29.2406L26.8702 12.2539",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6699 8.7V3.5",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8833 9.66984L49.7633 5.33984",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2299 9.66984L35.3533 5.33984",
    stroke: "#34303D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupersocialite);
export default __webpack_public_path__ + "static/media/supersocialite.bb637c3fd7c0537147ce45e07133e625.svg";
export { ForwardRef as ReactComponent };